import { EEnvironmentId } from "@calaosoft/osapp-common/environment/models/EEnvironmentId";
import { IEnvironment } from "@calaosoft/osapp-common/environment/models/IEnvironment";
import { Credentials } from "@calaosoft/osapp-common/security/models/credentials";

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const APP_ID = "merch";
export const APP_CORE_DATABASE_PREFIX = `${APP_ID}_core_`;

export const environment: IEnvironment = {
	production: false,
	id: EEnvironmentId.test,
	description: "TEST",
	cloud_url: "https://cloudtest.mobile.calaosoft.fr",
	coreRoleAppConfig: `${APP_CORE_DATABASE_PREFIX}common_app_configs`,
	statusBar: { backgroundColorByHexString: "#06cc00" },
	thumbnailLogo: "assets/icon/merch-icon-test.png",
	favicon: "assets/icon/merch-icon-test.png",

	cloud_api_suffix: "/api/",
	cloud_dms_suffix: "/dms/merch/documents/",
	cloud_api_data_suffix: `/api/apps/${APP_ID}/data/`,
	cloud_api_apps_suffix: `/api/apps/${APP_ID}/`,

	dms: {
		maxDocumentSizeKb: 51_200
	},

	appCredentials: Credentials.createFromLogin("merchapp", "deyozota81"),

	unlockRequired: true,

	API_KEY: "NWY4Y2E3ZDc2MDNiNDQ4ODg2YzM2ZmIzYjJmZTViZWU"
};

/** Url de connexion vers l'ERP Textilot. */
export const TEXTILOT_DASHBOARD_URL =
	"https://texpluserp-dev.w3plus.fr/account/login?returnUrl=%2Fdashboard&embedded=true&token={{externalToken}}";
